/* OK BYE — Grille de collection style « rhode » */
(function () {
  if (window.__okbyeCollectionInit) return;
  window.__okbyeCollectionInit = true;

  function closeChoosers(except) {
    document.querySelectorAll('.okbye-card__choose[open]').forEach(function (el) {
      if (el !== except) el.removeAttribute('open');
    });
  }

  // Un seul sélecteur de format ouvert à la fois
  document.addEventListener('toggle', function (e) {
    if (e.target.matches && e.target.matches('.okbye-card__choose') && e.target.open) {
      closeChoosers(e.target);
    }
  }, true);

  // Fermer en cliquant ailleurs
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.okbye-card__choose')) closeChoosers(null);
  });

  // Fermer avec Échap
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeChoosers(null);
  });

  // Les boutons <add-to-cart> sont des éléments personnalisés : on leur donne le clavier
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest && e.target.closest('.okbye-card add-to-cart');
    if (!btn) return;
    e.preventDefault();
    btn.click();
  });

  // Après un ajout au panier, refermer le sélecteur
  document.addEventListener('ajaxProduct:added', function () {
    closeChoosers(null);
  });

  // --- Gros noms : 2 lignes max, même taille pour toutes les cartes ---
  // On part de la taille max réglée dans l'éditeur et on descend jusqu'à ce que
  // le nom le plus long tienne sur 2 lignes (sans couper un mot).
  // Chaque liste de cartes (grille, carrousel, recommandations…) a sa propre taille uniforme.
  function fitAllLists() {
    var lists = [];
    document.querySelectorAll('.okbye-card').forEach(function (card) {
      var item = card.parentElement;
      var list = item && item.parentElement ? item.parentElement : item;
      if (list && lists.indexOf(list) === -1) lists.push(list);
    });
    lists.forEach(fitBigNames);
    uniformBigNames(lists);
    lists.forEach(fitTitles);
    lists.forEach(alignRows);
    if (DEBUG) debugCards();
  }

  // v58 — Même taille de gros nom partout : la plus petite taille calculée sur la page
  // (et gardée pour la session, par largeur d'écran) s'applique à toutes les listes.
  var BIG_KEY = 'okbyeBigFit2:' + (window.innerWidth < 750 ? 'm' : 'd');
  function uniformBigNames(lists) {
    var min = Infinity;
    lists.forEach(function (l) {
      var v = parseFloat(l.style.getPropertyValue('--okbye-big-fit'));
      if (v > 0) min = Math.min(min, v);
    });
    var saved = 0;
    try { saved = parseFloat(sessionStorage.getItem(BIG_KEY)) || 0; } catch (e) {}
    if (saved > 0) min = Math.min(min, saved);
    if (min === Infinity) return;
    try { sessionStorage.setItem(BIG_KEY, String(min)); } catch (e) {}
    lists.forEach(function (l) { l.style.setProperty('--okbye-big-fit', min + 'px'); });
  }

  // v58 — Mode diagnostic : ajoute ?okbye_debug=1 à l'adresse pour afficher les mesures sur chaque fiche
  var DEBUG = /[?&]okbye_debug=1/.test(location.search);
  function debugCards() {
    document.querySelectorAll('.okbye-card').forEach(function (card) {
      if (card.offsetParent === null) return;
      var media = card.querySelector('.okbye-card__media');
      var img = media && media.querySelector('img');
      var btn = card.querySelector('.okbye-card__add');
      var box = card.querySelector('.okbye-dbg');
      if (!box && media) { box = document.createElement('div'); box.className = 'okbye-dbg'; media.appendChild(box); }
      if (!box) return;
      var mr = media.getBoundingClientRect();
      var ir = img ? img.getBoundingClientRect() : { width: 0, height: 0 };
      var ms = getComputedStyle(media);
      var is = img ? getComputedStyle(img) : {};
      var bs = btn ? getComputedStyle(btn) : {};
      box.textContent =
        'fiche ' + Math.round(card.getBoundingClientRect().width) + 'x' + Math.round(card.getBoundingClientRect().height) +
        '\nboite ' + Math.round(mr.width) + 'x' + Math.round(mr.height) + ' h=' + ms.height + ' pt=' + ms.paddingTop + ' ar=' + ms.aspectRatio +
        '\nphoto ' + Math.round(ir.width) + 'x' + Math.round(ir.height) + ' pos=' + is.position + ' h=' + is.height + ' tr=' + is.transform +
        '\nsrc ' + (img ? img.naturalWidth + 'x' + img.naturalHeight : '-') +
        '\nbouton ' + (btn ? '"' + btn.textContent.trim().slice(0, 20) + '" ' + bs.color + ' ' + bs.fontSize : '-') +
        '\nnom ' + (getComputedStyle(card.querySelector('.okbye-card__big') || card).fontSize) +
        '\n' + navigator.userAgent.replace(/.*(iPhone OS [\d_]+|Version\/[\d.]+).*/, '$1');
    });
  }

  // Aligne les cartes d'une même rangée : le haut (gros nom + pastilles) et la ligne
  // titre/prix prennent la hauteur de la plus grande carte de la rangée, peu importe
  // la longueur des textes. Les photos et les boutons tombent donc tous au même niveau.
  var ALIGN_PARTS = ['.okbye-card__top', '.okbye-card__row', '.okbye-card__scents--bottom', '.okbye-card__low'];
  // Trouve le conteneur qui défile de côté (carrousel), s'il y en a un
  function scrollParent(el) {
    var n = el;
    for (var i = 0; i < 6 && n && n !== document.body; i++) {
      var cs = getComputedStyle(n);
      if ((cs.overflowX === 'auto' || cs.overflowX === 'scroll' || cs.overflowX === 'hidden' || cs.overflowX === 'clip') && n.scrollWidth > n.clientWidth + 4) return n;
      n = n.parentElement;
    }
    return null;
  }
  var scrollTimer;
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || t === document || !t.querySelector || !t.querySelector('.okbye-card')) return;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(fitAllLists, 120);
  }, true);
  // Carrousel : sa hauteur suit les fiches visibles (et non la plus haute de toute la liste)
  function fitScrollerHeight(scroller, list) {
    requestAnimationFrame(function () {
      var sr = scroller.getBoundingClientRect();
      var max = 0;
      list.querySelectorAll('.okbye-card').forEach(function (card) {
        var item = card.parentElement;
        var r = item.getBoundingClientRect();
        if (r.right > sr.left && r.left < sr.right) {
          // v53 : on mesure le CONTENU de la fiche (dernier élément + marge du bas), pas la fiche
          // elle-même : la fiche s'étire à la hauteur du carrousel, ce qui la faisait grandir
          // à chaque défilement (grand espace vide sous le bouton).
          var bottom = 0;
          Array.prototype.forEach.call(card.children, function (ch) {
            var cr = ch.getBoundingClientRect();
            if (cr.height > 0 && getComputedStyle(ch).position !== 'absolute') bottom = Math.max(bottom, cr.bottom);
          });
          if (!bottom) bottom = card.getBoundingClientRect().bottom;
          else bottom += parseFloat(getComputedStyle(card).paddingBottom) || 0;
          max = Math.max(max, bottom - sr.top);
        }
      });
      if (max > 0) {
        // v66 : on enlève une hauteur posée plus tôt sur un AUTRE conteneur (ex. sur ordinateur, le
        // carrousel change de conteneur qui défile une fois les images chargées : l'ancienne hauteur
        // restait et coupait les fiches sous la photo)
        var a = list;
        for (var i = 0; i < 6 && a && a !== document.body; i++) {
          if (a !== scroller && a.hasAttribute('data-okbye-fit')) {
            a.style.height = '';
            a.style.overflowY = '';
            a.removeAttribute('data-okbye-fit');
          }
          a = a.parentElement;
        }
        var pb = parseFloat(getComputedStyle(scroller).paddingBottom) || 0;
        scroller.style.height = Math.ceil(max + pb + 2) + 'px';
        scroller.style.overflowY = 'hidden';
        scroller.setAttribute('data-okbye-fit', '');
      }
    });
  }
  function alignRows(list) {
    var cards = Array.prototype.filter.call(
      list.querySelectorAll('.okbye-card'),
      function (el) { return el.offsetParent !== null; }
    );
    ALIGN_PARTS.forEach(function (sel) {
      cards.forEach(function (card) {
        var part = card.querySelector(sel);
        if (part) part.style.minHeight = '';
      });
    });
    cards.forEach(function (card) { card.style.minHeight = ''; });
    // Carrousel (liste qui défile de côté) : on aligne seulement les fiches visibles à l'écran,
    // pour ne pas réserver l'espace des fiches plus loin dans la liste.
    // v61 : toutes les fiches du carrousel sont alignées ensemble (avant : seulement les fiches
    // visibles, donc aucune sur mobile où une seule fiche est à l'écran → formats différents).
    var scroller = scrollParent(list);
    if (scroller) fitScrollerHeight(scroller, list);
    var rows = {};
    cards.forEach(function (card) {
      var key = Math.round(card.getBoundingClientRect().top);
      (rows[key] = rows[key] || []).push(card);
    });
    Object.keys(rows).forEach(function (key) {
      var row = rows[key];
      if (row.length < 2) return;
      ALIGN_PARTS.forEach(function (sel) {
        var parts = row.map(function (card) { return card.querySelector(sel); }).filter(Boolean);
        var max = 0;
        parts.forEach(function (p) { max = Math.max(max, p.getBoundingClientRect().height); });
        if (max) parts.forEach(function (p) { p.style.minHeight = max + 'px'; });
      });

    });
  }

  // Nom du produit sous la photo : 2 lignes max, jamais coupé ; même taille pour toute la liste
  function fitTitles(grid) {
    var titles = Array.prototype.filter.call(
      grid.querySelectorAll('.okbye-card__title'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!titles.length) return;
    grid.style.removeProperty('--okbye-title-fit');
    var max = parseFloat(getComputedStyle(titles[0]).fontSize);
    var min = Math.max(9, max * 0.7);
    function fits() {
      for (var i = 0; i < titles.length; i++) {
        var el = titles[i];
        var lh = parseFloat(getComputedStyle(el).lineHeight) || parseFloat(getComputedStyle(el).fontSize) * 1.25;
        if (el.scrollWidth > el.clientWidth + 1) return false; // un mot plus large que la fiche
      }
      return true;
    }
    if (fits()) return;
    var lo = min, hi = max;
    for (var step = 0; step < 7; step++) {
      var mid = (lo + hi) / 2;
      grid.style.setProperty('--okbye-title-fit', mid + 'px');
      if (fits()) lo = mid; else hi = mid;
    }
    grid.style.setProperty('--okbye-title-fit', Math.floor(lo * 2) / 2 + 'px');
  }
  function fitBigNames(grid) {
    var names = Array.prototype.filter.call(
      grid.querySelectorAll('.okbye-card__big'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!names.length) return;

    grid.style.removeProperty('--okbye-big-fit');
    var max = parseFloat(getComputedStyle(names[0]).fontSize);
    // Plancher : 50 % de la taille choisie. Au-delà, un nom très long passe sur une 3e ligne (jamais coupé).
    var min = Math.max(11, max * 0.5);

    function fitsAll() {
      for (var i = 0; i < names.length; i++) {
        var el = names[i];
        var size = parseFloat(getComputedStyle(el).fontSize);
        var lineHeight = parseFloat(getComputedStyle(el).lineHeight) || size;
        if (el.scrollHeight > lineHeight * 2 + 2) return false;
        if (el.scrollWidth > el.clientWidth + 1) return false;
      }
      return true;
    }

    if (fitsAll()) return;

    var lo = min;
    var hi = max;
    for (var step = 0; step < 8; step++) {
      var mid = (lo + hi) / 2;
      grid.style.setProperty('--okbye-big-fit', mid + 'px');
      if (fitsAll()) {
        lo = mid;
      } else {
        hi = mid;
      }
    }
    grid.style.setProperty('--okbye-big-fit', Math.floor(lo * 2) / 2 + 'px');
  }

  var fitTimer;
  function scheduleFit() {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(fitAllLists, 60);
  }

  // Réaligne aussi quand une liste devient visible (onglets, carrousels, sections chargées plus tard)
  var resizeObs = window.ResizeObserver ? new ResizeObserver(function () { scheduleFit(); }) : null;
  var watchedLists = [];
  function watchLists() {
    if (!resizeObs) return;
    document.querySelectorAll('.okbye-card').forEach(function (card) {
      var item = card.parentElement;
      var list = item && item.parentElement ? item.parentElement : item;
      if (list && watchedLists.indexOf(list) === -1) {
        watchedLists.push(list);
        resizeObs.observe(list);
      }
    });
  }

  var observing = false;
  function initFit() {
    scheduleFit();
    watchLists();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleFit);
    // v66 : une photo de fiche qui finit de charger change la hauteur → on réajuste
    document.addEventListener('load', function (e) {
      var t = e.target;
      if (t && t.tagName === 'IMG' && t.closest && t.closest('.okbye-card')) scheduleFit();
    }, true);
    window.addEventListener('load', function () { scheduleFit(); setTimeout(fitAllLists, 1500); setTimeout(fitAllLists, 4000); });
    // Clic sur un onglet (« Nouveau », « Les favoris de Jess »…) : la liste affichée change
    document.addEventListener('click', function () {
      setTimeout(scheduleFit, 80);
      setTimeout(scheduleFit, 450);
    });

    // « Charger plus », filtres, recommandations chargées plus tard, panier…
    if (!observing && window.MutationObserver) {
      observing = true;
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType === 1 && (node.matches('.okbye-card, .okbye-card *') || node.querySelector('.okbye-card'))) {
              scheduleFit();
              watchLists();
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  // Tri mobile (« Trier : … ») : recharge la page avec le nouveau tri
  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('[data-okbye-sort]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    scheduleFit();
  });

  document.addEventListener('shopify:section:load', initFit);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFit);
  } else {
    initFit();
  }

  // Tuile quiz : ouvre le quiz de la page s'il existe, sinon suit le lien
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-okbye-quiz-open]');
    if (!trigger) return;
    var quizButton = document.getElementById('okbye-qt-open');
    if (quizButton) {
      e.preventDefault();
      quizButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (quizButton.getAttribute('aria-expanded') !== 'true') quizButton.click();
    } else if (trigger.getAttribute('href') === '#') {
      e.preventDefault();
    }
  });
})();
